import { render, staticRenderFns } from "./IntegrationsList.vue?vue&type=template&id=228a5b10&"
import script from "./IntegrationsList.vue?vue&type=script&lang=js&"
export * from "./IntegrationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports